var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microaction/email",
    transform: "translate(0.000000, -1.000000)",
    fill: "#006F44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,-1.687539e-13 C17.5522847,-1.687539e-13 18,0.44771525 18,1 L18,14.7142857 C18,15.2665705 17.5522847,15.7142857 17,15.7142857 L1,15.7142857 C0.44771525,15.7142857 0,15.2665705 0,14.7142857 L0,1 C0,0.44771525 0.44771525,-1.687539e-13 1,-1.687539e-13 L17,-1.687539e-13 Z M1,4.622 L1,14.7142857 L17,14.7142857 L17,4.658 L9.40253297,10.3989479 C9.25087198,10.513525 9.05005498,10.5307457 8.88355324,10.4502129 L8.80354841,10.4017985 L1,4.622 Z M17,1 L1,1 L1,3.378 L9.09816362,9.37559675 L17,3.405 L17,1 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.ed4e6ef0900fac26030b7991a09b1ff4.svg";
export { ForwardRef as ReactComponent };